<template>
	<div class="storelinks">
		<b>{{$t("thank_you")}}</b>
	</div>
</template>

<script>
	export default {
		props: ['type'],
		methods:{
			showLogin(){
				this.$bus.$emit('showLogin')
			}
		}
	}
</script>

<style scoped>
	.storelinks{
		text-align: center;
		color: purple;
	}
	.play-badge, .appstore-badge{
		height: 40px;
		margin: 8px;
	}
	.email{
		max-width: 640px;
	}
</style>



// WEBPACK FOOTER //
// StoreLinks.vue?17baff4b